import mockData from "../../src/data/picklist_rubric.json";

export const fetchRubricType = (rubricCatKey) => (dispatch) => {
    const mockData = require("../../src/data/picklist_rubric.json")
    const oData = mockData.MasterrubricType;
    // mapping data
    dispatch({
        type: "SET_RUBRIC_TYPE", 
        payload: oData,
    });
    // return Promise.resolve();
    return new Promise((resolve) => {
        dispatch({
            type: "SET_RUBRIC_TYPE", 
            payload: oData,
        });
        resolve(oData);
      });
    // return RestService.get('Planning_CarryScore').then(
    //     (response) => {
    //         // mapping data
    //         dispatch({
    //             type: "SET_CARRY_SCORE",
    //             payload: response.data,
    //         });
    //         return Promise.resolve(response.data);
    //     },
    //     (error) => {
    //         const message =
    //             (error.response &&
    //                 error.response.data &&
    //                 error.response.data.message) ||
    //             error.message ||
    //             error.toString();
    //         dispatch({
    //             type: "REGISTER_FAIL",
    //         });
    //         dispatch({
    //             type: "SET_MESSAGE",
    //             payload: message,
    //         });
    //         return Promise.reject();
    //     }
    // );
};
export const fetchRubricCondition = (rubricCatKey) => (dispatch) => {
    const mockData = require("../../src/data/picklist_rubric.json")
    let oData = mockData.MasterRubricCon;
    // filter by rubric cat
    const aFilteredResults = oData.filter((loRow) => (loRow.RubricType[0] === rubricCatKey))
    aFilteredResults.forEach((loRow) => {
        loRow.ValueOfWork = loRow.ScoreValue / loRow.DivideValue;
        loRow.ValueOfWork = Math.round(loRow.ValueOfWork * 100) / 100
    })
    // mapping data
    dispatch({
        type: "SET_RUBRIC_CONDITION",
        payload: aFilteredResults,
    });
    // return Promise.resolve();
    return new Promise((resolve) => {
        dispatch({
            type: "SET_RUBRIC_CONDITION",
            payload: aFilteredResults,
        });
        resolve(aFilteredResults);
      });
    // return RestService.get('Planning_CarryScore').then(
    //     (response) => {
    //         // mapping data
    //         dispatch({
    //             type: "SET_CARRY_SCORE",
    //             payload: response.data,
    //         });
    //         return Promise.resolve(response.data);
    //     },
    //     (error) => {
    //         const message =
    //             (error.response &&
    //                 error.response.data &&
    //                 error.response.data.message) ||
    //             error.message ||
    //             error.toString();
    //         dispatch({
    //             type: "REGISTER_FAIL",
    //         });
    //         dispatch({
    //             type: "SET_MESSAGE",
    //             payload: message,
    //         });
    //         return Promise.reject();
    //     }
    // );
};
export const fetchMasterUnit = (rubricCatKey) => (dispatch) => {

    const mockData = require("../../src/data/picklist_rubric.json")
    const oData = mockData.MasterUnit;

    oData.forEach(()=>{

    })

    // filter by rubric cat
    // const aFilteredResults = oData.filter((loRow)=>(  loRow.RubricType[0] ===  rubricCatKey))
    // mapping data
    dispatch({
        type: "SET_UNIT",
        payload: oData,
    });
    return Promise.resolve();
    // return RestService.get('Planning_CarryScore').then(
    //     (response) => {
    //         // mapping data
    //         dispatch({
    //             type: "SET_CARRY_SCORE",
    //             payload: response.data,
    //         });
    //         return Promise.resolve(response.data);
    //     },
    //     (error) => {
    //         const message =
    //             (error.response &&
    //                 error.response.data &&
    //                 error.response.data.message) ||
    //             error.message ||
    //             error.toString();
    //         dispatch({
    //             type: "REGISTER_FAIL",
    //         });
    //         dispatch({
    //             type: "SET_MESSAGE",
    //             payload: message,
    //         });
    //         return Promise.reject();
    //     }
    // );
};
export const fetchMasterWorkload = () => (dispatch) => {

    const mockData = require("../../src/data/picklist_rubric.json")
    const oData = mockData.MasterWorkload;

    oData.forEach(()=>{

    })

    // filter by rubric cat
    // const aFilteredResults = oData.filter((loRow)=>(  loRow.RubricType[0] ===  rubricCatKey))
    // mapping data
    dispatch({
        type: "SET_WORKLOAD",
        payload: oData,
    });
    return Promise.resolve();
    // return RestService.get('Planning_CarryScore').then(
    //     (response) => {
    //         // mapping data
    //         dispatch({
    //             type: "SET_CARRY_SCORE",
    //             payload: response.data,
    //         });
    //         return Promise.resolve(response.data);
    //     },
    //     (error) => {
    //         const message =
    //             (error.response &&
    //                 error.response.data &&
    //                 error.response.data.message) ||
    //             error.message ||
    //             error.toString();
    //         dispatch({
    //             type: "REGISTER_FAIL",
    //         });
    //         dispatch({
    //             type: "SET_MESSAGE",
    //             payload: message,
    //         });
    //         return Promise.reject();
    //     }
    // );
};

